// sfx.json stores ZzFX parameters by name (no comma-count bugs; the same JSON feeds a Unity port). This maps a
// named recipe layer to the positional array the vendored buildSamples takes. No dependencies: the schema
// (DEV/tools) and the runtime audio code both import it.
import type { ZzfxParams } from './vendor/zzfx.ts';

/** ZzFX 1.3.2 parameter order. */
export const ZZFX_PARAM_ORDER = [
  'volume',
  'randomness',
  'frequency',
  'attack',
  'sustain',
  'release',
  'shape',
  'shapeCurve',
  'slide',
  'deltaSlide',
  'pitchJump',
  'pitchJumpTime',
  'repeatTime',
  'noise',
  'modulation',
  'bitCrush',
  'delay',
  'sustainVolume',
  'decay',
  'tremolo',
  'filter',
] as const;

export type ZzfxParamName = (typeof ZZFX_PARAM_ORDER)[number];
export type ZzfxNamed = { [K in ZzfxParamName]?: number | undefined };

/** Named → positional; missing names stay undefined so buildSamples applies the ZzFX defaults. */
export function toZzfxArray(p: Readonly<ZzfxNamed>): ZzfxParams {
  const out: (number | undefined)[] = ZZFX_PARAM_ORDER.map((k) => p[k]);
  while (out.length > 0 && out[out.length - 1] === undefined) out.pop();
  return out;
}
